(() => {
  const forms = document.querySelectorAll('.checkout-panel');

  forms.forEach((form) => {
    const amountRadios = form.querySelectorAll('input[name="contact[Donation amount]"]');
    const customAmount = form.querySelector('input[name="contact[Custom amount]"]');
    const section = form.closest('.checkout-layout');
    const summaryAmount = section?.querySelector('#summaryAmount');

    if (!amountRadios.length || !customAmount || !summaryAmount) return;

    function updateSummaryAmount() {
      const selected = form.querySelector('input[name="contact[Donation amount]"]:checked');
      if (!selected) return;
      if (selected.value === 'Custom') {
        summaryAmount.textContent = customAmount.value ? `$${customAmount.value}` : '$custom';
        return;
      }
      summaryAmount.textContent = selected.value;
    }

    amountRadios.forEach((radio) => radio.addEventListener('change', updateSummaryAmount));
    customAmount.addEventListener('focus', () => {
      const customRadio = form.querySelector('input[value="Custom"]');
      if (customRadio) customRadio.checked = true;
      updateSummaryAmount();
    });
    customAmount.addEventListener('input', updateSummaryAmount);
    updateSummaryAmount();
  });
})();
